import React from 'react';

export const AvatarGroupContext = React.createContext<{size?: number}>({});
